<template>
  <div class="wrap" ref="scrollBox">
    <div class="inbox" ref="inboxRef">
      <div class="bg_w">
        <div>
          <!--          {{ customerInboxHeight }}-->
          <!--          {{ customerInboxTop }}-->
          <!--          {{ topBoxValue }}-->
          <!--          {{ dragBoxHeight }}-->
          <span class="span" style="font-size: 13px">{{ $t('common.mailbox.kinds') }}：</span>
          <el-select
              style="width: 150px"
              v-model="emailType"
              @change="handleChangeEmail"
              class="m-2"
              size="small"
              :default-first-option="true"
          >
            <el-option
                v-for="item in emailListTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
          <span class="span" style="font-size: 13px">{{ $t('common.contact') }}：</span>
          <el-select
              v-model="emailSelect"
              @change="handleChangeContact"
              size="small"
              class="email-select"
          >
            <el-option
                v-for="item in emailList"
                :key="item.email"
                :label="formatLabel(item)"
                :value="item.email"
            >
              <template #default>
                <div class="option-row">
                  <span>{{ formatMain(item) }}</span>
                  <span v-if="formatSub(item)" class="sep"> - </span>
                  <span v-if="formatSub(item)" class="sub" style="font-weight: 600">{{ formatSub(item) }}</span>
                </div>
              </template>
            </el-option>
          </el-select>
        </div>
        <el-input
            style="width: 350px !important;"
            v-model="searchCount"
            :placeholder="$t('common.search.p.content')"
            class="input-with-select"
            clearable
            size="small"
            @clear="handleClickSearch('clear')"
            @keydown.enter.native="handleClickSearch"
        >
          <template #append>
            <el-button size="small" type="primary" :icon="Search" @click="handleClickSearch"/>
          </template>
        </el-input>
      </div>
      <div class="screen">
        <div class="screen_btn">
          <template v-if="type === 1 || type === 3">
            <ElButton size="small" @click="requestTagAllRead"
            >{{ $t('common.read.all') }}
            </ElButton
            >
            <ElButton size="small" @click="() => handleCommand('0')"
            >{{ $t('common.read.set') }}
            </ElButton
            >
            <ElButton size="small" @click="requestDelMail">{{ $t("common.delete") }}</ElButton>
            <ElButton size="small" v-if="type === 1">{{ $t('common.email.rubbish') }}</ElButton>
          </template>
          <ElButton size="small" v-if="type === 2" @click="requestDelMail(1)"
          >{{ $t('common.draft.delete') }}
          </ElButton
          >
          <ElButton size="small" v-if="type === 1">{{ $t('common.block') }}</ElButton>
          <template v-if="type === 5">
            <ElButton size="small" @click="requestTagAllRead"
            >{{ $t('common.read.all') }}
            </ElButton
            >
            <ElButton size="small" @click="() => requestDelMail(2)"
            >{{ $t('common.delete.empty') }}
            </ElButton
            >
            <ElButton size="small">{{ $t('common.block') }}</ElButton>
            <ElButton size="small" @click="() => requestDelMail(0)"
            >{{ $t('common.restore') }}
            </ElButton
            >
          </template>
        </div>
        <el-pagination
            v-model:current-page="current"
            v-model:page-size="size"
            small="small"
            v-if="total"
            layout="total, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
      </div>

      <!--      新的移动模块-->
      <div class="Drag2" ref="DragBox">
        <div class="box" ref="box">
          <!--      <div class="left">-->
          <!--        &lt;!&ndash;左侧div内容&ndash;&gt;-->
          <!--      </div>-->
          <!--      <div class="resize" title="左右侧边栏">⋮</div>-->
          <div class="mid">
            <!--右侧div内容-->
            <div class="topBox" :style="{height: topPanelHeight + 'px'}">
              <!--右上div内容-->
              <ElTable
                  v-loading="loading"
                  :data="tableData"
                  size="small"
                  :height="'100%'"
                  highlight-current-row
                  :default-sort="{ prop: 'date', order: 'descending' }"
                  @current-change="handleCurrentRowChange"
                  :cell-style="rowClassName"
                  :header-cell-style="headerClassName"
                  @row-dblclick="handleViewDetail"
                  @cell-mouse-enter="mouseEnters"
                  @cell-mouse-leave="mouseLeaves"
                  @select="handleClickSelect"
              >
                <el-table-column type="selection" width="30" fixed="left"/>
                <el-table-column width="30">
                  <template #header>
                    <img style="position: absolute;left: 6px;top:9px" src="@/assets/email/fj.svg"/>
                  </template>
                  <template #default="scope">
                    <img style="position: absolute;left: 6px;top:9px" v-if="scope.row.isExtend === 1" class="pointer"
                         src="@/assets/email/fj.svg"
                         @click.stop="() => handleDownload(scope)"/>
                  </template>
                </el-table-column>
                <el-table-column prop="contactName" :label="$t('common.contact')" width="200px"
                                 :show-overflow-tooltip="true">
                  <template #default="scope">
                    {{ scope.row.contactName != null ? scope.row.contactName : scope.row.customerName }}
                  </template>
                </el-table-column>
                <el-table-column width="18">
                  <template #default="scope">
                    <img
                        v-if="scope.row.urgent === 1"
                        src="../../assets/svg/warning.svg"
                        class="urgent-icon"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                    prop="subject"
                    :label="$t('common.subject')"
                >
                  <template #default="scope">
                    <div style="position: relative; display: flex; align-items: center;">
                      <!--                      &lt;!&ndash; 紧急图标 &ndash;&gt;-->
                      <!--                      <img-->
                      <!--                          v-show="scope.row.urgent === 1"-->
                      <!--                          class="pointer"-->
                      <!--                          src="../../assets/svg/warning.svg"-->
                      <!--                          style="position: absolute; left: -6px; top: 7px; width: 16px; height: 16px;"-->
                      <!--                      />-->
                      <!-- 主题文字，包裹在 el-tooltip 内 -->
                      <el-tooltip
                          effect="dark"
                          :show-after="1200"
                          placement="top"
                      >
                        <template #content>
                          <div
                              class="tooltip-content-wrap"
                          >
                            {{ scope.row.subject }}
                          </div>
                        </template>
                        <a @click.stop="handleViewDetail(scope.row)"
                           style="max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                          <span v-html="highlightKeyword(scope.row.subject, searchCount)"></span>
                        </a>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" :label="$t('common.remark')" width="80">
                  <template #default="scope">
                    <div class="flex">
                      <!--                         @click.stop="handleRef(refMap[`${scope.row.id}`], scope.row, 1)"-->
                      <el-icon :ref="(el) => (refMap[`${scope.row.id}`] = el)"
                               @click.stop="handleClickRemark(scope.row)"
                               :color="scope.row.remark ? '#40a9ff' : '#dddddd'" style="padding-top: -2px">
                        <el-tooltip
                            v-if="emailListCheckoutTarget.remark"
                            class="box-item"
                            :content="emailListCheckoutTarget.remark"
                            placement="right"
                            :show-after="1200"
                        >
                          <Memo/>
                        </el-tooltip>
                        <Memo v-else/>
                      </el-icon>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="type" :label="$t('common.mailbox.kinds')" :width="lang==='en'?120:50">
                  <template #default="scope">
                    <span v-if="scope.row.type === 1" style="color:#4c9f33">{{ $t('sys.note.j') }}</span>
                    <span v-else style="color:#b32518">{{ $t('sys.note.c') }}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="userName" :label="$t('common.number')" width="120">
                  <template #default="scope">
                    <div
                        :ref="(el) => setUserNameRef(el, scope.row)"
                        class="call-log-user-name"
                        :key="`${scope.row.id || scope.row.mailId || ''}_${scope.row.userName || ''}`"
                        @mouseenter.stop="handleUserNameMouseEnter(scope.row)"
                    >
                      {{ scope.row.userName }}
                    </div>
                  </template>
                </el-table-column> -->
                <el-table-column prop="sentDate" :label="$t('common.date')" sortable width="140">
                  <template #default="scope">
                    <span v-html="highlightKeyword(scope.row.sentDate, searchCount)"></span>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" :label="$t('common.cz')" :width="lang==='en'?150:100">
                  <template #default="scope">
                    <el-button
                        v-if="scope.row.type===1"
                        link
                        type="primary"
                        size="small"
                        @click.stop="handleReply(scope.row)"
                    >
                      {{ $t('common.reply') }}
                    </el-button>
                    <el-button v-else link
                               type="primary"
                               size="small"
                               @click.stop="handleResend(scope.row)">
                      {{ $t('common.resend') }}
                    </el-button>
                    <el-button link type="primary" size="small"
                               @click.stop="() => handleReplyDetail('forward',scope.row)"
                    >{{ $t('common.email.forward') }}
                    </el-button
                    >
                  </template>
                </el-table-column>
                <template #empty>
                  <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
                </template>
              </ElTable>
              <el-popover
                  v-model:visible="visibleUserNamePopover"
                  :virtual-ref="userNameTempRef"
                  virtual-triggering
                  :width="'max-content'"
                  trigger="hover"
                  :popper-style="{ minWidth: '60px', width: 'auto' }"
                  effect="dark"
                  placement="right"
                  :show-after="1200"
              >
                <div class="popover-content">{{ activeUserNameRow?.userName }}</div>
              </el-popover>
            </div>
            <div :title="$t('common.email.dragResizePanels')" class="mover">
              <div class="mail_info" ref="moveTarget">
                <div :title="$t('common.email.dragResizePanels')" class="up_row move" @pointerdown.prevent="handleVerticalResizeStart"></div>
                <div style="width: 100%;height: 26px;display: flex">
                  <div class="from over_text">
                    {{ $t('common.email.from') }}：{{ currentMail.mailBody?.from }}
                  </div>
                  <div class="to over_text" ref="toRef">
                    <el-popover
                        v-if="currentMailToText"
                        :visible="visibleTo"
                        width="500"
                        :content="currentMailToText"
                        :effect="'dark'"
                        popper-class="visible"
                    >
                      <template #reference>
                    <span @mouseenter="showPopover(currentMailToText,'to')"
                          @mouseleave="delayedHidePopover('to')">{{
                        $t('common.email.to')
                      }}：{{ currentMailToText }}</span>
                      </template>
                      <div @mouseenter="keepPopoverVisible('to')" @mouseleave="hidePopover('to')">
                        {{ currentMailToText }}
                      </div>
                    </el-popover>
                    <template v-else>
                      {{ $t('common.email.to') }}：{{ currentMailToText }}
                    </template>
                  </div>
                  <div class="cc over_text">
                    <el-popover
                        v-if="currentMailCcText"
                        :visible="visibleCC"
                        width="500"
                        :content="currentMailCcText"
                        :effect="'dark'"
                        popper-class="visible"
                    >
                      <template #reference>
                <span
                    @mouseenter="showPopover(currentMailCcText,'cc')"
                    @mouseleave="delayedHidePopover('cc')"
                >
                {{ $t('common.cc') }}：{{ currentMailCcText }}
                </span>
                      </template>
                      <div @mouseenter="keepPopoverVisible('cc')" @mouseleave="hidePopover('cc')">
                        {{ currentMailCcText }}
                      </div>
                    </el-popover>
                    <template v-else>
                      {{ $t('common.cc') }}：{{ currentMailCcText }}
                    </template>
                  </div>
                </div>
                <div :title="$t('common.email.dragResizePanels')" class="down_row move" @pointerdown.prevent="handleVerticalResizeStart"></div>
              </div>
            </div>
            <div class="downBox" :style="{height: downPanelHeight + 'px'}">
              <div class="mail-preview-wrapper">
                <div v-loading="detailLoading" class="mail-preview-frame">
                  <iframe ref="pageframe" id="pageframe" :srcdoc="iframeContent"
                          frameborder="0"
                          @load="handleIframeLoad"
                          :style="{width: '100%',height: '100%',pointerEvents: isDragging ? 'none' : 'auto'}"
                          :class="detailLoading?'scroll':'scroll loaded'"
                  ></iframe>
                  <div v-if="isDragging" id="mask"
                       :style="{position:'absolute',inset:'0',background:'rgba(0,0,0,0)',zIndex:999}">
                  </div>
                </div>
                <div v-if="showAttachmentPanel && attachmentList.length" class="attachment-panel">
                  <div class="attachment-panel-body">
                    <div
                        v-for="(item, index) in attachmentList"
                        :key="item.fileId || item.id || item.url || item.name || index"
                        class="file file-item"
                    >
                      <div class="attachment-item-main">
                        <FileIcon
                            :fileExtend="getAttachmentExt(item)"
                            :fileUrl="item.url"
                            :size="24"
                            :isAbbreviation="true"
                        />
                        <el-popover
                            placement="left"
                            :width="'max-content'"
                            effect="dark"
                            trigger="hover"
                            :content="item.name"
                            :show-after="1200"
                        >
                          <template #reference>
                            <a class="name contents text" @click.prevent="handleAttachmentDownload(item.url, item.name)">
                              {{ item.name }}
                            </a>
                          </template>
                        </el-popover>
                      </div>
                      <div class="attachment-item-meta">
                        {{ formatSize(item.extendSize) || '-' }}
                      </div>
                      <div class="attachment-item-actions">
                        <el-button link type="primary" size="small" @click="handleAttachmentDownload(item.url, item.name)">
                          {{ $t('common.download') }}
                        </el-button>
                        <el-button
                            v-if="canPreviewAttachment(item)"
                            link
                            type="primary"
                            size="small"
                            @click="handleDetailFile(item)"
                        >
                          {{ $t('common.preview') }}
                        </el-button>
                        <el-button link type="primary" size="small" @click="handleReSave(item)">
                          {{ $t('common.cloud.Rollover') }}
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MoveTargetFile
          v-if="moveTargetFileVisitable"
          v-model="moveTargetFileVisitable"
          @close="closeMoveTarget"
          :is-head-line="true"
          :type="2"
          :activeItem="activeItem"
          :list="refreshCurrentMailDetail"
          :numberFlag="'2'"
          :mail="true"
      ></MoveTargetFile>
      <!--   添加备注   -->
      <Remark v-if="visitableRemark" v-model="visitableRemark" @close="closeRemark" :isHeadLine="false"
              :currentItem="currentItem" @getList="getCustomerMailRecordApisList" :mailId="true"></Remark>
    </div>
  </div>
</template>
<script>
import {onMounted, ref, watch, computed, defineEmits, nextTick, reactive, onBeforeUnmount} from "vue";
import {
  getDefaultMailConfig,
  tagMail,
  tagAllRead,
  delMail,
  getMailDetails,
} from "../../api/index";
import {ElMessage} from "element-plus";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {Search} from "@element-plus/icons-vue";
import {getContactEmailListApis, getCustomerMailRecordApis, requestUpdateMailRemark} from "@/api/mail";
import {emptyUrl, htmlReg, POPOVER_DELAY_TIME} from '@/utils/statusParams'
import {debouncePlus, throttle} from "@/utils/mylodash"
import {
  audioFormat,
  downloadFile,
  excelFormat,
  formatSize,
  imgFormat,
  pdfFormat,
  pptFormat,
  textFormat,
  videoFormat,
  wordFormat
} from "@/utils/file";
import {getToken} from "@/utils/auth";
import {addImgOnErrorAttribute, containsHtmlTags, convertLinksToHTML, convertToHTML} from "@/utils/iframe";
import {i18n} from "@/lang";
import Remark from "@/components/Remark/index.vue";
import {highlightKeyword} from "@/utils/util";
import {replaceEmptyPTagsWithBr, resetCss} from "@/utils/TinyMCE";
import sessionStore from "@/utils/sessionStore";
import FileIcon from "@/components/File/FileIcon.vue";
import MoveTargetFile from "@/views/Cloud/Components/MoveTargetFile.vue";
import {api as viewerApi} from "v-viewer";

function buildRecipientTextMap(list) {
  if (!list || !list.length) {
    return {to: '', cc: ''};
  }
  const infoMap = {};
  list.forEach((item) => {
    if (!infoMap[item.mailType]) {
      infoMap[item.mailType] = [];
    }
    infoMap[item.mailType].push(item.mail);
  });
  return {
    to: infoMap.to ? infoMap.to.join(' , ') : '',
    cc: infoMap.cc ? infoMap.cc.join(' , ') : '',
  };
}

export default {
  components: {Remark, FileIcon, MoveTargetFile},
  methods: {highlightKeyword, formatSize},
  // (-1:失败邮件,1:收件箱,2:草稿箱,3:已发送,4:已删除,5:垃圾邮件)
  props: ["type", 'targetCheckoutItem'],
  setup(props, context) {
    const route = useRoute()
    const tableHeight = ref(200);
    const inboxRef = ref(null)
    const configId = ref("");
    const emailList = ref([]);
    const searchCount = ref("");
    const current = ref(1);
    const size = ref(20);
    const total = ref(0);
    const tableData = ref([]);
    const loading = ref(false);
    const multipleTableRef = ref(null);
    const multipleSelection = ref([]);
    const currentMail = ref({});
    const currentMailRecipientTextMap = computed(() => buildRecipientTextMap(currentMail.value?.mailRecipientVOList));
    const currentMailToText = computed(() => currentMailRecipientTextMap.value.to);
    const currentMailCcText = computed(() => currentMailRecipientTextMap.value.cc);
    const router = useRouter();
    const iframeContent = ref('');
    const lang = computed(() => store.state.system.langLocal)

    // 上下拖动事件
    const topBoxValue = ref(null);
    const downBoxValue = ref(null)
    // 移动
    const moveTarget = ref(null);
    const scrollBox = ref(null);
    const pageframe = ref(null);
    const isDragging = ref(false);
    const elementLeft = ref(0)

    const DragBox = ref()
    // 记录容器的最大高度
    const dragBoxHeight = ref(0)
    const showAttachmentPanel = ref(true);
    const attachmentList = computed(() => currentMail.value?.mailExtendList || []);
    const previewableAttachmentTypes = Object.freeze([
      ...imgFormat,
      ...pdfFormat,
      ...wordFormat,
      ...excelFormat,
      ...videoFormat,
      ...audioFormat,
      ...pptFormat,
      ...textFormat
    ]);

    const emailListTypes = ref([{label: i18n.global.t('common.all'), value: 0}, {
      label: i18n.global.t('sys.note.j'),
      value: 1
    }, {
      label: i18n.global.t('sys.note.c'),
      value: 2
    },])
    // 选中的 邮件
    const emailType = ref(0)
    const userInfo = computed(() => store.state.user.userInfo)
    // 选中的 联系人
    const emailSelect = computed(() => {
      return props.targetCheckoutItem.islink ? props.targetCheckoutItem.targetCheckoutItem : emailSelectTarget.value
    })
    const emailSelectTarget = ref(i18n.global.t('common_all'))

    const store = useStore();
    const teamId = computed(() => store.state.email.teamID);

    watch(() => emailSelect.value, () => {
      if (props.targetCheckoutItem.islink) {
        getCustomerMailRecordApisList()
      }
    })

    const commandList = [1, 0, 1, 0];

    async function handleDownload(scope) {
      const targetType = scope.row.type === 1 ? 1 : 3;
      window.open(`${location.origin}/email/detail/${scope.row.mailId}/${JSON.stringify({
        flag: scope.row.flag ? scope.row.flag : 0,
        isExtend: scope.row.isExtend ? scope.row.isExtend : 0,
        from: scope.row.from
      })}/${targetType}`);
    }

    const handleViewDetail = (row) => {
      //邮件已读
      multipleSelection.value = [row]
      requestTagMail(commandList[0], 'isRead');
      // 没有 type 来源，这里指定 type 类型
      const targetType = row.type === 1 ? 1 : 3;
      window.open(`${location.origin}/email/detail/${row.mailId}/${JSON.stringify({
        flag: row.flag ? row.flag : 0,
        isExtend: row.isExtend ? row.isExtend : 0,
        from: row.from,
        customerId: row.customerId,
      })}/${targetType}`);
      getCustomerMailRecordApisList()
    }

    // 回复
    function handleReply(row) {
      sessionStore.set('reSend', row)
      const query = {id: row.mailId, customerId: row.customerId}
      // router.push({
      //   path: '/email/write_mail',
      //   query: {id: row.mailId, customerId: row.customerId},
      // });
      const queryString = new URLSearchParams(query).toString();
      // 拼接完整 URL（假设是 hash 模式或 history 模式可视项目结构调整）
      const url = `${location.origin}/email/write_mail?${queryString}`;
      // 在新标签页打开
      window.open(url, '_blank');
    }

    function handleResend(row) {
      sessionStore.set('reSend', row)
      const query = {
        id: row.mailId,
        flag: row.flag,
        type: "resend",
        mailType: 3 || 2,
        customerId: route.params.userId,
      };
      if (row.flag === 0 && row.customerId) {
        query.customerId = row.customerId;
      }
      // router.push({
      //   path: '/email/write_mail',
      //   query,
      // });
      const queryString = new URLSearchParams(query).toString();

      // 拼接完整 URL（假设是 hash 模式或 history 模式可视项目结构调整）
      const url = `${location.origin}/email/write_mail?${queryString}`;

      // 在新标签页打开
      window.open(url, '_blank');
    }


    function handleReplyDetail(stringType = '', row) {
      if (!row.mailId) {
        return;
      }
      const query = {
        id: row.mailId,
        type: stringType,
        mailType: 1,
        customerId: row.customerId
      }
      if (stringType === "") {
        delete query.type;
      }
      console.log(query, 'payload')
      // router.push({
      //   path: '/email/write_mail',
      //   query,
      // });
      // 构造 query 参数字符串
      const queryString = new URLSearchParams(query).toString();

      // 拼接完整 URL（假设是 hash 模式或 history 模式可视项目结构调整）
      const url = `${location.origin}/email/write_mail?${queryString}`;

      // 在新标签页打开
      window.open(url, '_blank');
    }

    async function getConfig() {
      const res = await getDefaultMailConfig(teamId);
      const {id} = res.result;
    }


    function handleSizeChange() {
    }

    function handleCurrentChange(page) {
      current.value = page;
      // getMailList();
      getCustomerMailRecordApisList()
    }

    function handleSelectionChange(val) {
      multipleSelection.value = val;
    }

    async function requestTagMail(tag) {
      const result = await tagMail({
        [type]: tag,
        mailIdList: multipleSelection.value.map(item => item.id),
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      // getMailList();
      getCustomerMailRecordApisList()
    }

    async function requestTagAllRead() {
      const result = await tagAllRead();
      // getMailList();
      getCustomerMailRecordApisList()
    }

    async function requestDelMail(flag = 1, isSelect) {
      if (isSelect) {
        multipleSelection.value.push(isSelect)
      }
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      
      // 构建请求参数
      const params = {
        type: flag, // 0 还原  1 已删除 2彻底删除
        mailIdList: multipleSelection.value.map(item => item.mailId),
      };
      
      // 只有 type: 1 时才需要传递 originalPosition
      if (flag === 1) {
        params.originalPosition = isSelect?.originalPosition 
          || multipleSelection.value[0]?.originalPosition;
      }
      
      const result = await delMail(params);
      if (result.code !== 200) {
        ElMessage.error(result.msg);
        return;
      }
      ElMessage.success(i18n.global.t("sys.message.success.delete"));
      setTimeout(() => {
        // getMailList();
        getCustomerMailRecordApisList()
      }, 1500);
    }

    const activeItems = ref({})
    const detailLoading = ref(false)
    const getTargetMailId = ref("")

    async function handleCurrentRowChange(current) {
      if (current) {
        getTargetMailId.value = current.mailId;
      }
      activeItems.value = current
      if (current !== null) {
        detailLoading.value = true
        try {
          const result = await getMailDetails({id: current.mailId});
          let content = result.result?.mailBody?.content;
          const insertionContent = `<script>
            function errorImage(img) {
                img.onerror = null;
                img.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVR42mP4//8/AAX+Av4zEpUUAAAAAElFTkSuQmCC"
            }
        <\/script>`;
          if (!content) {
            iframeContent.value = replaceEmptyPTagsWithBr(resetCss + '')
          } else {
            if (containsHtmlTags(content)) {
              const replacedHtmlString = addImgOnErrorAttribute(content)
              const res = replacedHtmlString.replace(/(<html[^>]*>)/, '$1' + insertionContent);
              iframeContent.value = replaceEmptyPTagsWithBr(resetCss + res);
            } else {
              if (content.indexOf('https://s3gw.cmbimg.com') !== -1) {
                iframeContent.value = replaceEmptyPTagsWithBr(resetCss + content);
              } else {
                iframeContent.value = replaceEmptyPTagsWithBr(resetCss + convertLinksToHTML(convertToHTML(content)));
              }
            }
          }
          currentMail.value = result.result;
          detailLoading.value = false
        } catch (e) {
          detailLoading.value = false
        }
      }
    }

    function handleCommand(val) {
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      requestTagMail(val);
    }

    function formatText(list, type) {
      if (!list || !list.length) {
        return '';
      }
      const infoMap = list.reduce((prev, item) => {
        if (!prev[item.mailType]) {
          prev[item.mailType] = [];
        }
        prev[item.mailType].push(item.mail);
        return prev;
      }, {});
      return infoMap[type] ? infoMap[type].join(',') : '';
    }

    function getAttachmentExt(item = {}) {
      const fileName = item.name || item.fileName || '';
      const extIndex = fileName.lastIndexOf('.');
      if (extIndex === -1) {
        return '';
      }
      return fileName.substring(extIndex + 1).toLowerCase();
    }

    function canPreviewAttachment(item = {}) {
      return previewableAttachmentTypes.includes(getAttachmentExt(item));
    }

    async function handleAttachmentDownload(url, fileName) {
      try {
        if (!url) {
          ElMessage.error('文件地址无效');
          return;
        }

        const safeUrl = url.replace(/^http:\/\//i, "https://");
        const response = await fetch(safeUrl, {method: "GET"});

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();
        downloadFile(blob, fileName || safeUrl.split("/").pop() || "download");
      } catch (error) {
        console.error('下载失败:', error);
        ElMessage.error("下载失败，请稍后重试");
      }
    }

    function openAttachmentWindow(url) {
      window.open(url, "_blank");
    }

    function buildOpenUrl(path, row, extra = "") {
      if (!row || !row.url || !row.name) {
        return "";
      }
      const safeUrl = row.url.replace(/^http:\/\//i, "https://");
      const ext = getAttachmentExt(row);

      return `${location.origin}/${path}`
          + `?url=${encodeURIComponent(safeUrl)}`
          + `&type=${encodeURIComponent(ext)}`
          + extra;
    }

    function showTargetPdf(row) {
      openAttachmentWindow(buildOpenUrl("showfile", row));
    }

    function showTargetText(row) {
      openAttachmentWindow(buildOpenUrl("showtext", row));
    }

    function showTargetVideo(row) {
      openAttachmentWindow(buildOpenUrl("showvideo", row));
    }

    function showTargetAudio(row) {
      openAttachmentWindow(buildOpenUrl("showaudio", row, `&title=${encodeURIComponent(row.name)}`));
    }

    function showTargetFile(row) {
      const images = [];
      let initialViewIndex = 0;

      attachmentList.value
          .filter(item => imgFormat.includes(getAttachmentExt(item)))
          .forEach((item) => {
            if (item.name === row.name) {
              initialViewIndex = images.length;
            }
            images.push({src: item.url?.replace(/^http:\/\//i, "https://") || ""});
          });

      viewerApi({
        images,
        options: {
          initialViewIndex
        }
      })
    }

    function handleDetailFile(item) {
      const fileExtend = getAttachmentExt(item);

      if (imgFormat.includes(fileExtend)) {
        showTargetFile(item)
      } else if (pdfFormat.includes(fileExtend)) {
        showTargetPdf(item);
      } else if (wordFormat.includes(fileExtend) || excelFormat.includes(fileExtend) || pptFormat.includes(fileExtend)) {
        window.open("https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(item.url))
      } else if (textFormat.includes(fileExtend)) {
        showTargetText(item)
      } else if (videoFormat.includes(fileExtend)) {
        showTargetVideo(item)
      } else if (audioFormat.includes(fileExtend)) {
        showTargetAudio(item)
      } else {
        handleAttachmentDownload(item.url, item.name)
      }
    }

    const moveTargetFileVisitable = ref(false);
    const activeItem = ref([]);
    const closeMoveTarget = () => {
      moveTargetFileVisitable.value = false
      activeItem.value = []
    }
    const handleReSave = throttle((item) => {
      activeItem.value = [item]
      moveTargetFileVisitable.value = true
    }, 500)
    const refreshCurrentMailDetail = async () => {
      if (!getTargetMailId.value) {
        return;
      }
      await handleCurrentRowChange({mailId: getTargetMailId.value});
    }

    function handleSettingStress(scope, type) {
      multipleSelection.value = [scope.row];
      handleCommand(type);
    }


// 获取邮件配置
    const getCustomerMailRecordApisList = async () => {
      loading.value = true
      const customerId = window.localStorage.getItem('customerId');
      const teamId = sessionStore.get('teamId')
      const targetObj = {
        customerId,
        "pageNo": current.value,
        "pageSize": size.value,
        "search": isClear.value ? "" : searchCount.value,
        teamId,
        email: emailSelect.value === i18n.global.t('common_all') ? "" : emailSelect.value,
        "type": emailType.value
      }
      let res = await getCustomerMailRecordApis(targetObj);
      if (res.code !== 200) {
        ElMessage.error(res.message)
        return
      }
      loading.value = false
      const {records} = res.result;
      tableData.value = records;
      total.value = res.result.total;
      current.value = res.result.current;
      size.value = res.result.size;
    }


    const isClear = ref(false)
// 点击搜索框
    const handleClickSearch = (flag) => {
      if (flag === "clear") {
        isClear.value = true;
      } else {
        isClear.value = false;
      }
      getCustomerMailRecordApisList()
    }

    const getContactEmailListApisList = async () => {
      // customerId 不同步问题
      const customerId = router.currentRoute.value.params
      window.localStorage.setItem('customerId', customerId.userId);
      let res = await getContactEmailListApis({customerId: customerId.userId});
      if (res.code !== 200) {
        ElMessage.error(res.message);
        return;
      }
      emailList.value = [...res.result, {
        email: i18n.global.t('common_all'),
        contactEmail: i18n.global.t('common_all'),
      }].filter(item => item.email !== "");
    }

    // 页面进行缩放
    const adjustContentPosition = debouncePlus(async () => {
      await nextTick()
      syncDragBoxHeight();
      await store.dispatch("system/getTargetHeight", {userId: userInfo.value.id})
      await nextTick()
      applyStoredVerticalPanelsHeight();
    }, 200)

    onMounted(async () => {
      await store.dispatch("system/getTargetHeight", {userId: userInfo.value.id})
      await nextTick()
      syncDragBoxHeight();
      applyStoredVerticalPanelsHeight();
      await getContactEmailListApisList();
      await getCustomerMailRecordApisList()

      window.addEventListener('resize', adjustContentPosition);
    });

    onBeforeUnmount(() => {
      clearIframeScrollState();
      clearVerticalResizeState();
      window.removeEventListener('resize', adjustContentPosition);
    });

    const handleChangeEmail = () => {
      getCustomerMailRecordApisList()
    }
    const handleChangeContact = (val) => {
      emailSelectTarget.value = val
      context.emit('change', {islink: false})
      getCustomerMailRecordApisList()
    }

    async function setRemark(id, val) {
      if (val.length > 30) {
        ElMessage.warning(i18n.global.t('common.email.setBlockSize'))
        activeItems.value.remark = "";
        return;
      } else {
        const result = await requestUpdateMailRemark({id, remark: val});
        if (result.code !== 200) {
          ElMessage.error(result.message);
          return;
        }
      }
    }

    const minTopPanelHeight = 30;
    const minBottomPanelHeight = 0;
    const verticalPanelGap = 0;
    const verticalResizeBarHeight = 30;
    let verticalResizeFrame = null;
    let removeVerticalResizeListeners = null;
    let removeIframeScrollListeners = null;
    let iframeWheelFallbackFrame = null;
    const getMaxTopPanelHeight = () => Math.max(dragBoxHeight.value - minBottomPanelHeight - verticalPanelGap, minTopPanelHeight)
    const getClampedTopPanelHeight = (height) => {
      const safeHeight = Number.isFinite(height) ? height : minTopPanelHeight;
      return Math.min(Math.max(safeHeight, minTopPanelHeight), getMaxTopPanelHeight());
    }
    const getStoredCustomerInboxLayoutTop = () => {
      const storedTop = Number(store.state.system.customerInboxTop);
      if (Number.isFinite(storedTop) && storedTop > 0) {
        return storedTop;
      }

      const storedBottomHeight = Number(store.state.system.customerInboxHeight);
      if (dragBoxHeight.value && Number.isFinite(storedBottomHeight) && storedBottomHeight >= 0) {
        return dragBoxHeight.value - storedBottomHeight - verticalPanelGap;
      }

      return minTopPanelHeight;
    }
    const syncVerticalPanelsHeight = (nextTopHeight) => {
      if (!dragBoxHeight.value) return;
      const fallbackTopHeight = Number.isFinite(topBoxValue.value) ? topBoxValue.value : getStoredCustomerInboxLayoutTop();
      const topHeight = getClampedTopPanelHeight(nextTopHeight ?? fallbackTopHeight);
      topBoxValue.value = topHeight;
      downBoxValue.value = Math.max(dragBoxHeight.value - topHeight - verticalPanelGap, minBottomPanelHeight);
      elementTopRaw.value = topHeight;
      pageframeHeightRaw.value = downBoxValue.value;
    }
    const applyStoredVerticalPanelsHeight = () => {
      if (!dragBoxHeight.value) return;
      syncVerticalPanelsHeight(getStoredCustomerInboxLayoutTop());
    }
    const syncDragBoxHeight = () => {
      if (!DragBox.value) return;
      dragBoxHeight.value = Math.max(DragBox.value.offsetHeight - verticalResizeBarHeight, 0);
      syncVerticalPanelsHeight();
    }
    const topPanelHeight = computed(() => Number.isFinite(topBoxValue.value) ? topBoxValue.value : getClampedTopPanelHeight(store.state.system.customerInboxTop || minTopPanelHeight))
    const downPanelHeight = computed(() => {
      if (Number.isFinite(downBoxValue.value)) return downBoxValue.value;
      if (!dragBoxHeight.value) return Math.max(store.state.system.customerInboxHeight || minBottomPanelHeight, minBottomPanelHeight);
      return Math.max(dragBoxHeight.value - topPanelHeight.value - verticalPanelGap, minBottomPanelHeight);
    })
    const customerInboxTop = computed(() => topPanelHeight.value)
    const customerInboxHeight = computed(() => downPanelHeight.value)

    const elementTopRaw = ref(customerInboxTop.value);
    const elementTop = computed({
      get() {
        return elementTopRaw.value;
      },
      set(newValue) {
        elementTopRaw.value = newValue;
      },
    });

    const pageframeHeightRaw = ref(customerInboxHeight.value);
    const pageframeHeight = computed({
      get() {
        return pageframeHeightRaw.value;
      },
      set(newValue) {
        pageframeHeightRaw.value = newValue;
      },
    });

    const saveTargetHeight = debouncePlus((userId, pageframeHeight, elementTop) => {
      store.dispatch("system/settingTargetHeight", {
        userId,
        customerInboxHeight: pageframeHeight,
        customerInboxTop: elementTop
      });
    }, 200);

    const rowClassName = ({row, column, rowIndex, columnIndex}) => {
      if (columnIndex === 4 || columnIndex === 3 || columnIndex === 2 || columnIndex === 0 || columnIndex === 1) {
        return {textAlign: 'left'}
      } else {
        return {textAlign: 'center'}
      }
    }

    const headerClassName = ({row, column, rowIndex, columnIndex}) => {
      if (columnIndex === 4 || columnIndex === 3 || columnIndex === 2 || columnIndex === 0 || columnIndex === 1) {
        return {'text-align': 'left',}
      } else {
        return {'text-align': 'center'}
      }
    }


    const visibleTo = ref(false)
    const visibleCC = ref(false)

    const hidePopoverTimeout = ref(false)

    function showPopover(string = '', flag) {

      if (moveTarget.value) {
        const itemWidth = Math.round((moveTarget.value.clientWidth - 40) * (1 / 3))
        const stringWidth = string.pxWidth('normal 12px PingFangSC, PingFang SC')
        if (stringWidth + 20 > itemWidth) {
          if (flag === "to") {
            visibleCC.value = false;
            visibleTo.value = true;
          } else if (flag === "cc") {
            visibleTo.value = false;
            visibleCC.value = true;
          }
          if (hidePopoverTimeout.value) {
            clearTimeout(hidePopoverTimeout.value);
            hidePopoverTimeout.value = null;
          }
        }
      }
    }

    function delayedHidePopover(flag) {
      hidePopoverTimeout.value = setTimeout(() => {
        flag === "to" ? visibleTo.value = false : visibleCC.value = false;
      }, 200); // Adjust delay as necessary
    }

    function keepPopoverVisible(flag) {
      if (hidePopoverTimeout.value) {
        clearTimeout(hidePopoverTimeout.value);
        hidePopoverTimeout.value = null;
      }
      flag === "to" ? visibleTo.value = true : visibleCC.value = true;
    }

    function hidePopover(flag) {
      flag === "to" ? visibleTo.value = false : visibleCC.value = false;
    }


    const refMap = ref([])
    const userNameRefMap = ref({})
    const userNameTempRef = ref(null)
    const visibleUserNamePopover = ref(false)
    const activeUserNameRow = ref(null)
    const userNameOverflowMap = reactive({})

    const getUserNameRowKey = (row) => {
      return row?.id ?? `${row?.mailId ?? ''}_${row?.userName ?? ''}`
    }

    const setUserNameRef = (el, row) => {
      if (!el || !row) return
      const key = getUserNameRowKey(row)
      userNameRefMap.value[key] = el
      nextTick(() => {
        const target = userNameRefMap.value[key]
        if (!target) return
        userNameOverflowMap[key] = Math.ceil(target.scrollWidth) > Math.ceil(target.clientWidth)
      })
    }

    const showUserNamePopover = debouncePlus((ref, row) => {
      userNameTempRef.value = ref
      activeUserNameRow.value = row
      visibleUserNamePopover.value = true
    }, POPOVER_DELAY_TIME)

    const handleUserNameMouseEnter = (row) => {
      const key = getUserNameRowKey(row)
      if (!userNameOverflowMap[key]) {
        showUserNamePopover.cancel()
        visibleUserNamePopover.value = false
        return
      }
      showUserNamePopover(userNameRefMap.value[key], row)
    }

    const clearUserNamePopover = () => {
      showUserNamePopover.cancel()
      setTimeout(() => {
        visibleUserNamePopover.value = false
      }, POPOVER_DELAY_TIME + 10)
    }

    const tempRef = ref(null)
    const visiblePopover = ref(false)
    const emailListCheckoutTarget = ref({remark: ''})
    const handleRef = debouncePlus((ref, item, type) => {
      tempRef.value = ref
      visiblePopover.value = true;
      emailListCheckoutTarget.value = item;
    }, 500)

    const hidePopoverTimeoutModel = ref(false)
    // 这里是开始点
    const mouseEnters = debouncePlus((row) => {
      emailListCheckoutTarget.value = row;
    }, 200)

    const mouseLeaves = () => {
      clearUserNamePopover()
      hidePopoverTimeoutModel.value = setTimeout(() => {
        visiblePopover.value = false;
      }, 300);
    }
    const keepPopoverVisibleModel = () => {
      if (hidePopoverTimeoutModel.value) {
        clearTimeout(hidePopoverTimeoutModel.value);
        hidePopoverTimeoutModel.value = null;
      }
      visiblePopover.value = true;
    }

    const hidePopoverModel = () => {
      visiblePopover.value = false;
    }

    const cancelPopover = () => {
      visiblePopover.value = false;
      emailListCheckoutTarget.value.remark = ''
    }

    const handleClickSelect = (val) => {
      console.log(val, 'val')
      multipleSelection.value = val;
    }


    // 弹窗进行编辑备注
    const visitableRemark = ref(false)
    const currentItem = ref({remark: ""})
    const handleClickRemark = (row) => {
      const {id} = row
      console.log(id, row, 'id')
      currentItem.value = row
      visitableRemark.value = true
    }
    const closeRemark = () => {
      visitableRemark.value = false
    }


    function updateVerticalPanelsHeight(moveLen, containerHeight) {
      dragBoxHeight.value = containerHeight;
      syncVerticalPanelsHeight(moveLen);
      saveTargetHeight(userInfo.value.id, downBoxValue.value, topBoxValue.value);
    }

    function clearIframeScrollState() {
      if (iframeWheelFallbackFrame) {
        cancelAnimationFrame(iframeWheelFallbackFrame);
        iframeWheelFallbackFrame = null;
      }
      if (removeIframeScrollListeners) {
        removeIframeScrollListeners();
        removeIframeScrollListeners = null;
      }
    }

    function emitIframeScrollEvent() {
      const iframeEl = pageframe.value;
      const iframeDoc = iframeEl?.contentDocument;
      if (!iframeEl || !iframeDoc) {
        return;
      }
      const scrollTarget = iframeDoc.scrollingElement || iframeDoc.documentElement || iframeDoc.body;
      if (!scrollTarget) {
        return;
      }
      iframeEl.dispatchEvent(new Event('scroll'));
      iframeEl.dispatchEvent(new CustomEvent('iframe-scroll', {
        detail: {
          scrollTop: scrollTarget.scrollTop || 0,
          scrollLeft: scrollTarget.scrollLeft || 0,
          clientHeight: scrollTarget.clientHeight || 0,
          scrollHeight: scrollTarget.scrollHeight || 0,
        }
      }));
    }

    function bindIframeScrollListeners() {
      clearIframeScrollState();
      nextTick(() => {
        const iframeEl = pageframe.value;
        const iframeWin = iframeEl?.contentWindow;
        const iframeDoc = iframeEl?.contentDocument;
        if (!iframeEl || !iframeWin || !iframeDoc) {
          return;
        }

        const onIframeScroll = () => {
          if (isDragging.value) {
            return;
          }
          emitIframeScrollEvent();
        };
        const onIframeWheel = (event) => {
          const scrollTarget = iframeDoc.scrollingElement || iframeDoc.documentElement || iframeDoc.body;
          const beforeScrollTop = scrollTarget?.scrollTop || 0;
          const deltaY = event.deltaY || 0;
          if (isDragging.value || !scrollTarget || !deltaY) {
            return;
          }
          if (iframeWheelFallbackFrame) {
            cancelAnimationFrame(iframeWheelFallbackFrame);
          }
          iframeWheelFallbackFrame = requestAnimationFrame(() => {
            const activeScrollTarget = iframeDoc.scrollingElement || iframeDoc.documentElement || iframeDoc.body;
            if (!activeScrollTarget || activeScrollTarget.scrollHeight <= activeScrollTarget.clientHeight) {
              iframeWheelFallbackFrame = null;
              return;
            }
            if (activeScrollTarget.scrollTop === beforeScrollTop) {
              const maxScrollTop = Math.max(activeScrollTarget.scrollHeight - activeScrollTarget.clientHeight, 0);
              const nextScrollTop = Math.min(Math.max(beforeScrollTop + deltaY, 0), maxScrollTop);
              if (nextScrollTop !== beforeScrollTop) {
                activeScrollTarget.scrollTop = nextScrollTop;
                emitIframeScrollEvent();
              }
            }
            iframeWheelFallbackFrame = null;
          });
        };
        const passiveOptions = {passive: true};

        iframeWin.addEventListener('scroll', onIframeScroll, passiveOptions);
        iframeDoc.addEventListener('scroll', onIframeScroll, passiveOptions);
        iframeDoc.documentElement?.addEventListener('scroll', onIframeScroll, passiveOptions);
        iframeDoc.body?.addEventListener('scroll', onIframeScroll, passiveOptions);
        iframeWin.addEventListener('wheel', onIframeWheel, passiveOptions);
        iframeDoc.addEventListener('wheel', onIframeWheel, passiveOptions);
        iframeDoc.documentElement?.addEventListener('wheel', onIframeWheel, passiveOptions);
        iframeDoc.body?.addEventListener('wheel', onIframeWheel, passiveOptions);

        removeIframeScrollListeners = () => {
          iframeWin.removeEventListener('scroll', onIframeScroll, passiveOptions);
          iframeDoc.removeEventListener('scroll', onIframeScroll, passiveOptions);
          iframeDoc.documentElement?.removeEventListener('scroll', onIframeScroll, passiveOptions);
          iframeDoc.body?.removeEventListener('scroll', onIframeScroll, passiveOptions);
          iframeWin.removeEventListener('wheel', onIframeWheel, passiveOptions);
          iframeDoc.removeEventListener('wheel', onIframeWheel, passiveOptions);
          iframeDoc.documentElement?.removeEventListener('wheel', onIframeWheel, passiveOptions);
          iframeDoc.body?.removeEventListener('wheel', onIframeWheel, passiveOptions);
        };

        requestAnimationFrame(() => {
          emitIframeScrollEvent();
        });
      });
    }

    function handleIframeLoad() {
      bindIframeScrollListeners();
    }

    function clearVerticalResizeState() {
      isDragging.value = false
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
      if (verticalResizeFrame) {
        cancelAnimationFrame(verticalResizeFrame);
        verticalResizeFrame = null;
      }
      if (removeVerticalResizeListeners) {
        removeVerticalResizeListeners();
        removeVerticalResizeListeners = null;
      }
    }

    function handleVerticalResizeStart(e) {
      syncDragBoxHeight();
      const containerHeight = dragBoxHeight.value;
      if (!containerHeight) return false;
      const startY = e.clientY;
      const startTop = topPanelHeight.value;
      const pointerTarget = e.currentTarget;
      const pointerId = e.pointerId;

      isDragging.value = true
      document.body.style.cursor = "row-resize";
      document.body.style.userSelect = "none";
      if (pointerTarget && Number.isFinite(pointerId)) {
        try {
          pointerTarget.setPointerCapture(pointerId);
        } catch (error) {
          console.warn('setPointerCapture failed', error);
        }
      }

      const handleMouseUp = () => {
        if (pointerTarget && Number.isFinite(pointerId)) {
          try {
            pointerTarget.releasePointerCapture(pointerId);
          } catch (error) {
            console.warn('releasePointerCapture failed', error);
          }
        }
        clearVerticalResizeState();
        saveTargetHeight(userInfo.value.id, downPanelHeight.value, topPanelHeight.value);
        requestAnimationFrame(() => {
          bindIframeScrollListeners();
        });
      };
      const handleVisibilityChange = () => {
        if (document.visibilityState !== 'visible') {
          handleMouseUp();
        }
      };

      const handleMouseMove = (moveEvent) => {
        if (moveEvent.buttons === 0) {
          handleMouseUp();
          return;
        }
        const deltaY = moveEvent.clientY - startY;
        const moveLen = startTop + deltaY;
        if (verticalResizeFrame) {
          cancelAnimationFrame(verticalResizeFrame);
        }
        verticalResizeFrame = requestAnimationFrame(() => {
          updateVerticalPanelsHeight(moveLen, containerHeight);
          verticalResizeFrame = null;
        });
      };

      removeVerticalResizeListeners = () => {
        window.removeEventListener('pointermove', handleMouseMove);
        window.removeEventListener('pointerup', handleMouseUp);
        window.removeEventListener('pointercancel', handleMouseUp);
        window.removeEventListener('blur', handleMouseUp);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
      window.addEventListener('pointermove', handleMouseMove);
      window.addEventListener('pointerup', handleMouseUp);
      window.addEventListener('pointercancel', handleMouseUp);
      window.addEventListener('blur', handleMouseUp);
      document.addEventListener('visibilitychange', handleVisibilityChange);

      return false;
    }

    function getContactEmailText(item) {
      return item?.contactEmail || item?.email || ''
    }

    function formatMain(item) {
      const contactEmail = getContactEmailText(item)
      const match = contactEmail.match(/^(.+?)\((.+)\)$/)
      return match ? match[1] : contactEmail
    }

    function formatSub(item) {
      const contactEmail = getContactEmailText(item)
      const match = contactEmail.match(/^(.+?)\((.+)\)$/)
      return match ? match[2] : ''
    }

    function formatLabel(item) {
      const contactEmail = getContactEmailText(item)
      if (contactEmail === i18n.global.t('common_all')) {
        return contactEmail
      }
      const main = formatMain(item)
      const sub = formatSub(item)
      return sub ? `${main} - ${sub}` : main
    }

    return {
      formatMain,
      formatSub,
      formatLabel,
      lang,
      handleReplyDetail,
      topBoxValue,
      dragBoxHeight,
      DragBox,
      currentMailToText,
      currentMailCcText,
      showAttachmentPanel,
      attachmentList,
      getAttachmentExt,
      canPreviewAttachment,
      handleAttachmentDownload,
      handleDetailFile,
      moveTargetFileVisitable,
      activeItem,
      closeMoveTarget,
      handleReSave,
      refreshCurrentMailDetail,
      topPanelHeight,
      downPanelHeight,
      handleVerticalResizeStart,
      currentItem,
      closeRemark,
      visitableRemark,
      handleClickRemark,
      handleClickSelect,
      cancelPopover,
      emailListCheckoutTarget,
      hidePopoverModel,
      keepPopoverVisibleModel,
      mouseLeaves,
      mouseEnters,
      handleRef,
      visiblePopover,
      tempRef,
      refMap,
      setUserNameRef,
      handleUserNameMouseEnter,
      visibleUserNamePopover,
      userNameTempRef,
      activeUserNameRow,
      showPopover,
      delayedHidePopover, keepPopoverVisible, hidePopover,
      detailLoading,
      handleIframeLoad,
      visibleTo,
      visibleCC,
      handleDownload,
      handleViewDetail,
      handleResend,
      headerClassName,
      rowClassName,
      pageframeHeight,
      pageframe,
      elementLeft,
      elementTop,
      scrollBox,
      moveTarget,
      setRemark,
      configId,
      emailList,
      tableData,
      current,
      size,
      total,
      loading,
      multipleTableRef,
      handleCommand,
      currentMail,
      handleSizeChange,
      handleCurrentChange,
      handleCurrentRowChange,
      handleSettingStress,
      handleSelectionChange,
      requestTagAllRead,
      requestDelMail,
      getCustomerMailRecordApisList,
      getContactEmailListApisList,
      emailListTypes,
      emailType,
      emailSelect,
      searchCount,
      Search,
      handleClickSearch,
      handleReply,
      formatText,
      iframeContent,
      handleChangeEmail,
      handleChangeContact,
      tableHeight,
      inboxRef,
      emptyUrl,
      isDragging,
      customerInboxHeight,
      customerInboxTop,
      elementTopRaw,
      pageframeHeightRaw
    };
  },
}
;
</script>
<style lang="less" scoped>
:deep(.el-table .read_0) {
  font-weight: 700 !important;
}

.wrap {
  background-color: rgb(245, 245, 245);
  padding: 8px 8px 0px 8px;
  height: -webkit-fill-available !important;

  .inbox .bg_w {
    & :deep(.el-select) {
      width: 150px !important;
    }
  }
}

.fx-j-e {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.pointer {
  cursor: pointer;
}

.inbox {
  background-color: #fff;
  position: relative;
}

.bg_w {
  padding: 4px;
  display: flex;
  align-items: center;

  .span {
    font-size: 13px;
    font-weight: normal;
    color: var(--el-text-color-regular)
  }
}

.input-with-select {
  width: 350px;
  margin-right: 10px;
}

.screen {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  background-color: #f5f5f5;

  .el-button + .el-button {
    margin-left: 2px;
  }

  .el-dropdown {
    margin-left: 2px;
  }
}

.current_mail {

  .mail_info {
    display: flex;
    flex-direction: column;
    height: 30px;
    align-items: center;
    background: rgb(229, 229, 229);
    //user-select: text;
    cursor: n-resize;
    transform: translateZ(0);
    will-change: transform;
    font-family: "PingFangSC, PingFang SC";

    & > div:nth-of-type(2) {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 0px 20px;
      height: 26px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      cursor: text !important;

      & > div {
        width: 33.33%;
        min-width: 33.33% !important;
        max-width: 33.33% !important;
      }
    }
  }
}

.box_titles {
  position: relative;
  height: max-content;
  border-top: 1px solid #e8e8e8;
}

.inner_card {
  margin: 30px 0px 30px 40px;
}

.sp_box {
  width: 45% !important;
}

.footer_box {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;

  .el-button {
    margin: 0px 10px;
  }
}

.box_titles:nth-of-type(1)::after {
  content: '选择建档邮箱';
  position: absolute;
  top: -12px;
  left: 34px;
  text-align: center;
  font-size: 16px;
  color: black;
  background: white;
  padding: 0px 10px;
}

.box_titles:nth-of-type(2)::after {
  content: '选择归档客户';
  position: absolute;
  top: -12px;
  left: 34px;
  text-align: center;
  font-size: 16px;
  color: black;
  background: white;
  padding: 0px 10px;
}

.box_titles:nth-of-type(3)::after {
  content: '选择已有联系人';
  position: absolute;
  top: -12px;
  left: 34px;
  text-align: center;
  font-size: 16px;
  color: black;
  background: white;
  padding: 0px 10px;
}

.box_titles_created {
  position: relative;
  height: max-content;
  border-top: 1px solid #e8e8e8;
}

.box_titles_created::after {
  content: '新建联系人';
  position: absolute;
  top: -12px;
  left: 34px;
  text-align: center;
  font-size: 16px;
  color: black;
  background: white;
  padding: 0px 10px;
}

.sp_buttons {
  margin-left: 20px;
  position: absolute;
  left: 105%;
}

.my_forms {
  margin-top: 20px;
}

:deep(.el-form-item__content) {
  flex-wrap: nowrap !important;
}

.wrap :deep(.el-form-item) {
  margin: 20px 0 0;
}

.el-form-item__content > div {
  position: relative;
}

:deep(.el-scrollbar__bar.is-horizontal) {
  height: 0 !important;
}

:deep(.el-scrollbar__wrap) {
  overflow-x: hidden !important;
}

:deep(.el-input-group__append) {
  padding: 0 20px 0 0;
}

:deep(.el-input-group__append button.el-button) {
   background: var(--el-color-primary);
  color: white;
  width: 76px;
  border-radius: 0px 4px 4px 0px !important;
}

.bg_w {
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: max-content;
  }

  .span {
    width: max-content;
    min-width: max-content;
    font-size: 14px;
    color: var(--el-text-color-regular)
  }
}

:deep(.el-select) {
  margin-right: 20px;
}


.scroll_out_box {
  position: relative;
  min-height: calc(100vh - 164px) !important;
  max-height: calc(100vh - 164px) !important;
}

.mail_info {
  width: 100%;
  height: 26px;
  user-select: text;
}

.mail_info :deep(span),
.mail_info :deep(div) {
  user-select: text;
}

.screen_btn {
  button:nth-of-type(1) {
    margin-left: 0px !important;
  }

  button {
    margin-left: 2px !important;
  }
}

.up_row, .down_row {
  width: 100%;
  height: 2px !important;
  cursor: row-resize !important;
}

.over_text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 26px;
  width: 33.33%;
  text-align: left;
  color: black !important;
}

iframe {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

iframe.loaded {
  opacity: 1;
}

:deep(.el-popper) {
  max-width: 45% !important;
}

.visible {
  padding: 0px !important;

  & > div {
    margin: -12px !important;
    padding: 8px !important;
  }
}

.sp_model_popover {
  padding: 0px !important;

  & > div {
    margin: -12px !important;
    padding: 12px !important;
  }
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.el-scrollbar__bar.is-horizontal) {
  height: 6px !important;
}

.Drag2 {
  height: calc(100vh - 230px);
}

/*包围div样式*/
.box {
  width: 100%;
  height: 100%;
  margin: 0px 0px 20px 0px;
  overflow: hidden;
  //box-shadow: -1px 9px 10px 3px rgba(0, 0, 0, 0.11);
}

/*左侧div样式*/
.left {
  width: calc(32% - 10px); /*左侧初始化宽度*/
  height: 100%;
  background: #71ad88;
  float: left;
}

/* 拖拽区div样式 */
.resize {
  cursor: w-resize;
  float: left;
  position: relative;
  top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  margin-top: -10px;
  width: 10px;
  height: 50px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 32px;
  color: white;
}

/*拖拽区鼠标悬停样式*/
//.movers:hover {
//  color: #444444;
//}

/*右侧div'样式*/
.mid {
  float: left;
  width: 100%; /*右侧初始化宽度*/
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f3f3f3;
  box-shadow: -1px 4px 5px 3px rgba(0, 0, 0, 0.11);
  /*上方div'样式*/

  .topBox {
    flex: 0 0 auto;
    min-height: 0;
    background-color: #3ff53f;
    display: flex;
  }

  /*下方div'样式*/

  .downBox {
    flex: 0 0 auto;
    min-height: 0;
    background: white !important;
    display: flex;
    overflow: hidden;
  }

  /* 拖拽区div样式 */

  .mover {
    flex: 0 0 30px;
    padding: 0px 20px;
    cursor: row-resize;
    width: 100%;
    height: 30px;
    background-color: #d6d6d6;
    border-radius: 5px;
    text-align: center;
    line-height: 3px;
    font-size: 12px;
  }

  /*拖拽区鼠标悬停样式*/

  .mover:hover {
    color: #444444;
  }
}

.urgent-icon {
  width: 15px;
  height: 15px;
  position: relative;
  top: 3px;
}

.call-log-user-name {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.5;
}

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

//.email-select {
//  width: 300px;
//}
//
//.email-select .el-input__inner {
//  white-space: nowrap;
//  overflow: hidden;
//  text-overflow: ellipsis;
//}

.mail-preview-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
}

.mail-preview-frame {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
}

.attachment-panel {
  width: 250px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex-shrink: 0;
  font-size: 13px;
}

.attachment-panel-body {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 0 0;
}

.file {
  display: flex;
  flex-direction: column;
  padding: 8px;
  margin: 0 8px 8px;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 4px;
}

.attachment-item-main {
  display: flex;
  align-items: center;
  min-width: 0;
}

.attachment-item-main .name {
  margin-left: 8px;
  color: #40a9ff;
  font-size: 13px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  min-width: 0;
  flex: 1 1 auto;
}

.attachment-item-meta {
  margin-top: 4px;
  color: #909399;
  font-size: 13px;
  line-height: 20px;
}

.attachment-item-actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-top: 4px;
  flex-wrap: wrap;
}

.attachment-item-actions :deep(.el-button) {
  font-size: 13px !important;
}
//
//.el-select-dropdown__item {
//  max-width: 300px; /* 控制下拉最大宽度 */
//  overflow: hidden;
//  text-overflow: ellipsis;
//  white-space: nowrap;
//}
</style>
